import React, { useState } from "react";
import { registerUser } from "../../api"; // adjust path based on your folder structure
import { useNavigate } from "react-router-dom";

const Register = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    F_name: "",
    L_name: "",
    email: "",
    password: "",
    phone_number: "",
    user_type: "user", // default user_type
  });

  const [message, setMessage] = useState("");

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await registerUser(form);
      setMessage(`✅ ${res.data.message}`);
      setTimeout(() => {
        navigate("/login");
      }, 1000);
    } catch (err) {
      console.log(err);
      setMessage(`❌ ${err.response?.data?.message || "Something went wrong"}`);
    }
  };

  return (
    <div id="wrapper">
      <div id="page">
        <div className="sign-in-wrap">
          <div className="sign-in-box">
            <div className="left">
              <div className="content">
                <h3 className="heading">Hello 👋</h3>
                <div className="sub f12-regular text-GrayDark">
                  Welcome again to our website
                </div>

                <div className="sign-in-inner">
                  <h4>Create An Account</h4>

                  <form
                    className="form-login flex flex-column gap24"
                    onSubmit={handleSubmit}
                  >
                    <fieldset className="name">
                      <div className="f14-regular mb-6">First name</div>
                      <input
                        type="text"
                        name="F_name"
                        placeholder="Enter your first name"
                        value={form.F_name}
                        onChange={handleChange}
                        required
                      />
                    </fieldset>

                    <fieldset className="name">
                      <div className="f14-regular mb-6">Last name</div>
                      <input
                        type="text"
                        name="L_name"
                        placeholder="Enter your last name"
                        value={form.L_name}
                        onChange={handleChange}
                        required
                      />
                    </fieldset>

                    <fieldset className="email">
                      <div className="f14-regular mb-6">Email</div>
                      <input
                        type="email"
                        name="email"
                        placeholder="Enter your email"
                        value={form.email}
                        onChange={handleChange}
                        required
                      />
                    </fieldset>

                    <fieldset className="password">
                      <div className="f14-regular mb-6">Password</div>
                      <input
                        type="password"
                        name="password"
                        placeholder="Enter your password"
                        value={form.password}
                        onChange={handleChange}
                        required
                      />
                    </fieldset>

                    <fieldset className="phone">
                      <div className="f14-regular mb-6">Phone number</div>
                      <input
                        type="text"
                        name="phone_number"
                        placeholder="Enter your phone number"
                        value={form.phone_number}
                        onChange={handleChange}
                        required
                      />
                    </fieldset>

                    <button
                      type="submit"
                      className="tf-button style-1 label-01 w-100"
                    >
                      Sign Up
                    </button>
                  </form>

                  {message && <p>{message}</p>}

                  <div className="f14-regular">
                    Already have an account?{" "}
                    <a href="/login" className="f14-bold">
                      Sign In
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div className="right">
              <img src="images/item/bg-sign-in.jpg" alt="" />
              <div className="text">
                <img className="mb-12" src="images/item/sign-up.png" alt="" />
                <h3 className="mb-24 text-White">
                  Buy & sell Each Digital <br /> Cryptocurrency
                </h3>
                <div className="f14-regular text-White">
                  Easily Buy bitcoin and other cryptocurrencies using <br />
                  wide range of payment option. Discover exclusive <br />
                  digital collection of us.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;
